// extracted by mini-css-extract-plugin
var _1 = "ShipmentTracking_backCopy__3sy24";
var _2 = "ShipmentTracking_container__-fERM";
var _3 = "ShipmentTracking_disclaimer__qtsec";
var _4 = "ShipmentTracking_feedbackButtonsContainer__DD3lO";
var _5 = "ShipmentTracking_link__2djqP";
var _6 = "ShipmentTracking_pageContent__3xgaj";
var _7 = "ShipmentTracking_shipmentDetails__OBKPv";
var _8 = "ShipmentTracking_shipmentDetailsTitle__ncoEK";
export { _1 as "backCopy", _2 as "container", _3 as "disclaimer", _4 as "feedbackButtonsContainer", _5 as "link", _6 as "pageContent", _7 as "shipmentDetails", _8 as "shipmentDetailsTitle" }
